import { call, put, takeLatest } from "@redux-saga/core/effects";
import { DASHBOARD_ACTION, errorDashboardList, errorDashboardMonthlyHours, errorEmpDashboardList, responseDashboardList, responseDashboardMonthlyHours, responseEmpDashboardList } from "./dashBoardActionCreator";
import DashBoardService from "../../Services/RestApiManager/DashBoardManager/DashBoardService";

export function* dashBoardListRequest(action) {
    try {
      const response = yield call(DashBoardService.shared.dashBoardListRequest, action.data);
      yield put(responseDashboardList(response));
    } catch (error) {
      yield put(errorDashboardList(error));
    }
  }
 export function* empDashBoardListRequest(action) {
    try {
      const response = yield call(DashBoardService.shared.empDashBoardListRequest, action.data);
      yield put(responseEmpDashboardList(response));
    } catch (error) {
      yield put(errorEmpDashboardList(error));
    }
  }

  export function* DashboardMonthlyHoursRequest(action) {
    try {
      const response = yield call(DashBoardService.shared.dashboardMOnthlyHoursRequest, action.data);
      yield put(responseDashboardMonthlyHours(response));
    } catch(error) {
      yield put(errorDashboardMonthlyHours(error));
    }
  }

  export function* dashBoardWatcherSaga() {
    yield takeLatest(DASHBOARD_ACTION.REQUEST_DASHBOARD_LIST , dashBoardListRequest);
    yield takeLatest(DASHBOARD_ACTION.REQUEST_EMP_DASHBOARD_LIST , empDashBoardListRequest);
    yield takeLatest(DASHBOARD_ACTION.REQUEST_DASHBOARD_MONTHLYHOURS, DashboardMonthlyHoursRequest);
  }

